import { render, staticRenderFns } from "./TheTableStaff.vue?vue&type=template&id=73522934&scoped=true&"
import script from "./TheTableStaff.vue?vue&type=script&lang=ts&"
export * from "./TheTableStaff.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73522934",
  null
  
)

export default component.exports